import _ from 'lodash';
import GatewayService from '../GatewayService.js';
var score = new GatewayService('score-service');

var fetchScores = function fetchScores() {
  var userList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var cardstackKey = arguments.length > 1 ? arguments[1] : undefined;

  if (_.isString(userList)) {
    userList = [userList];
  }

  var params = {
    appGroup1Id: cardstackKey
  };
  return score.post('api/0.2/score/find/curriculum', userList, {
    params: params
  });
};

var fetchScoresForCardstacks = function fetchScoresForCardstacks(userKeys, cardstackKeys) {
  var params = {
    userBusinessKeys: userKeys,
    appGroup1Ids: cardstackKeys
  };
  return score.post('api/0.2/score/batchfind/curriculum', params);
};

var saveScores = function saveScores(scoreEntries) {
  return score.post('api/0.2/score', scoreEntries);
};

export default {
  fetchScores: fetchScores,
  fetchScoresForCardstacks: fetchScoresForCardstacks,
  saveScores: saveScores
};